import API from "../api/phx";

export class Logs {
  static LOGS_API = "logs/add";
  static CHUNK_SIZE = 5;

  static uniqueEvents = [];
  static orderId = "-1";
  static events = [];

  // this are sent after the orderID is created
  static provisionalEvents = [];
  static intervalId;
  static autoLoggerStarted = false;
  static autoLoggerInterval = 300;
  // in case the customer doesn't produce anymore logs
  static autoLoggerAutoFlush = 10000;

  // idle/busy
  static state = "idle";

  static SetOrderId(orderId) {
    this.orderId = orderId;
    this.provisionalEvents.map((log) =>{
      this.AddEvent(log);
    });
  }

  static AddErrorEvent(event, unique) {
    this.AddEvent(`ERROR: ${event}`, unique);
  }

  static AddProvisionalEvent(event) {
    if(this.orderId !== -1) {
      this.AddEvent(event)
      return;
    }

    this.provisionalEvents.push(event);
  }

  static AddEvent(event, unique) {

    if(unique === true) {
      if (this.uniqueEvents.includes(event)) {
        return;
      }
      this.uniqueEvents.push(event);
    }

    const date = new Date();

    const options = {
      year: "numeric",
      month: "2-digit",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZone: "Europe/London",
    };

    const dateString = date.toLocaleDateString("en-GB", options);

    // Split the date string into its components
    try {
      const [datePart, timePart] = dateString.split(",");
      const [day, month, year] = datePart.split("/");
      const [time, meridian] = timePart.trim().split(" ");

      // Split the time into hours, minutes, and seconds
      const [hour, minute, second] = time
        .split(":")
        .map((part) => parseInt(part, 10));

      // Determine if it's PM and adjust the hour accordingly
      const adjustedHour = meridian === "PM" ? hour + 12 : hour;

      const reconstructedDate = new Date(
        year,
        month - 1,
        day,
        adjustedHour,
        minute,
        second
      );

      this.events.push({
        position: `FE Logs -> ${event}`,
        timestamp: reconstructedDate.getTime() / 1000,
      });
    } catch (err) {
      console.error("Error pushing event: ", err);
    }
  }


  static StartAutoSender() {

    if (this.autoLoggerStarted) {
      return;
    }

    this.autoLoggerStarted = true
    this.intervalId = setInterval(() => {

      if (this.events.length >= this.CHUNK_SIZE && this.state == "idle") {
        this.SendEvents();
      }
    }, this.autoLoggerInterval);


    window.onunload = () => {
      // Flush everything
      this.SendEvents();
      clearInterval(this.intervalId);
    }

    setInterval(() => {
      if (this.state == "idle") {
        this.SendEvents();
      }
    }, this.autoLoggerAutoFlush);

  }

  static SendEvents() {
    if (this.events.length == 0) {
      return
    }

    const data = {
      order_id: this.orderId,
      events: this.events,
    };

    this.state = "busy";

    try {
      API.post(this.LOGS_API, data, { withCredentials: true }).then(() => {
        this.events = [];
        this.state = "idle";
      });
    } catch(err) {
      console.error("Error sending logs: ",err);
    }
  }
}
